export default "__VITE_ASSET__1c9ce624__"